@if (isVisible()) {
  <p-button
    [class]="type() + '-jenz-button'"
    [styleClass]="customClass()"
    [label]="label() | translate"
    [size]="size()"
    [loading]="loading()"
    [disabled]="disabled()"
    [rounded]="true"
    [text]="textValue"
    [icon]="icon()"
    [type]="buttonType()"
    [pTooltip]="tooltip()"
    [tooltipPosition]="tooltipPosition()"
    (onClick)="click($event)"
  >
    <ng-content></ng-content>
  </p-button>
}
